import mapKnownValues from "../../../utils/mapKnownValues";

export default class MarketingMaterialPostcard {
  type = "";
  mailDate = new Date();

  constructor(params: Partial<MarketingMaterialPostcard>) {
    mapKnownValues(this, params);
  }
}
